import { BackendModel, BackendService } from '../core/backend.service';

export class TipoMoneda extends BackendModel {

  static path = '/parametricas/tipos_monedas/';
  id: number;
  simbolo: string;

  constructor(protected backendService: BackendService, model?: TipoMoneda) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/tipoMoneda.model.ts